export default __webpack_public_path__ + "static/assets/images/cookie.48a7917af3d7fa07aeb603f299d9f091.svg";